import React, { useState, useEffect } from 'react';
import styles from './Admin.module.css';
import { toast } from 'react-toastify';

export default function Admin() {
  const [email, setEmail] = useState('');
  const [courseId, setCourseId] = useState('bio');
  const [lists, setLists] = useState({ granted: [], revoked: [] });

  const fetchLists = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/access-list?courseId=${courseId}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      setLists({
        granted: Array.isArray(data.granted) ? data.granted : [],
        revoked: Array.isArray(data.revoked) ? data.revoked : []
      });
    } catch (err) {
      toast.error('Error al cargar accesos');
      console.error('Error fetching access list:', err);
    }
  };

  useEffect(() => {
    fetchLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId]);

  const handle = async (action) => {
    if (!email) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/admin/${action}`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, courseId })
        }
      );
      const data = await res.json();

      if (res.ok) {
        toast.success(data.message);
        setEmail('');
        fetchLists();
      } else {
        toast.error(data.message || 'Error en la solicitud');
      }
    } catch (err) {
      console.error('Error en handle()', err);
      toast.error('Ocurrió un error al procesar la solicitud');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Panel Admin</h1>

        <div className={styles.field}>
          <label htmlFor="email">Email usuario</label>
          <input
            id="email"
            type="email"
            className={styles.inputOne}
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="usuario@dominio.com"
          />
        </div>

        <div className={styles.field}>
          <label htmlFor="course">Selecciona curso</label>
          <select
            id="course"
            className={styles.input}
            value={courseId}
            onChange={e => setCourseId(e.target.value)}
          >
            <option value="bio">Bioquímica</option>
            <option value="emb">Embriología</option>
            <option value="fisi">Fisiología</option>
          </select>
        </div>

        <div className={styles.buttons}>
          <button
            className={`${styles.btn} ${styles.btnGrant}`}
            onClick={() => handle('grant')}
            disabled={!email}
          >
            Conceder acceso
          </button>
          <button
            className={`${styles.btn} ${styles.btnRevoke}`}
            onClick={() => handle('revoke')}
            disabled={!email}
          >
            Revocar acceso
          </button>
        </div>
      </div>
      <div className={styles.panelContainer}>
        <div className={styles.listCard}>
          <h2 className={styles.subTitle}>Accesos concedidos</h2>
          {lists.granted.length > 0 ? (
            <ul className={styles.list}>
              {lists.granted.map((user, i) => (
                <li key={i} className={styles.listItem}>
                  <strong>{user.email}</strong> — cursos: {user.courses.join(', ')}
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.empty}>No hay usuarios con acceso.</p>
          )}
        </div>
        <div className={styles.listCard}>
          <h2 className={styles.subTitle}>Accesos revocados</h2>
          {lists.revoked.length > 0 ? (
            <ul className={styles.list}>
              {lists.revoked.map((user, i) => (
                <li key={i} className={styles.listItem}>
                  <strong>{user.email}</strong> — cursos: {user.courses.length > 0 ? user.courses.join(', ') : 'ninguno'}
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.empty}>No hay accesos revocados.</p>
          )}
        </div>

      </div>
    </div>
  );
}
